import { render, staticRenderFns } from "./AssetBelongsToModal.vue?vue&type=template&id=8be4689e"
import script from "./AssetBelongsToModal.vue?vue&type=script&lang=js"
export * from "./AssetBelongsToModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports